import React from "react";
import { ChannelProvider } from "../../hooks";
import Skeleton from "../Ui/Skeleton/Skeleton";
import UserList from "../UserList";
import NoMessageBox from "./NoMessageBox";
import ChannelMember from "../ChannelMember/ChannelMember";
const ChannelPanel = ({ isLoading, isUserListOpen, selectedChannel, handleNewChat, isOpenChannelMembers, handleLeaveGroup, handleSendMessage, handleEscapeEvent, children, }) => {
    if (isLoading)
        return React.createElement(Skeleton, null);
    if (isUserListOpen) {
        return (React.createElement(UserList, { handleEscapeEvent: handleEscapeEvent, handleNewChat: handleNewChat }));
    }
    if (selectedChannel) {
        return (React.createElement(ChannelProvider, { channel: selectedChannel }, isOpenChannelMembers ? (React.createElement(ChannelMember, { handleEscapeEvent: handleEscapeEvent, handleLeaveGroup: handleLeaveGroup, handleSendMessage: handleSendMessage })) : (children)));
    }
    return React.createElement(NoMessageBox, null);
};
export default ChannelPanel;
//# sourceMappingURL=ChannelPanel.js.map